<template>
  <div>
    <cc-bounced
        :title="bouncedParam.title"
        :visible="bouncedParam.visible"
        :beforeClose="closeBounced"
        :canShowFooter="bouncedParam.canShowFooter"
        :layout="bouncedParam.layout"
        :loading="bouncedParam.loading"
        @transmitCancel="closeBounced"
        class="expire-bounced" >
        <div class="bounced-content accountLookDetails" slot="content" v-loading="dataLoading">
          <div class="vh-between mb20 bounced-title">
              <span class="mr30">科目：{{selectData.subjectName}}</span>
              <div class="text-danger">
                <span>借方发生额（{{$formatNumber(selectData.debitMoney)}}）</span>
                <span class="ml10">贷方发生额（{{$formatNumber(selectData.lenderMoney)}}）</span>
              </div>
            </div>
          <!-- 其他凭证 -->
          <div class="accountLookDetails-other" id="other" >
            <p class="subtitle">一、其他发票</p>
            <template>
              <div v-for="(item, i) in resObj.vouOtherInvoice" :key="i" class="page-always">
                <preview-voucher
                  v-if="item.accVoucher"
                  :list="item.accVoucher ? item.accVoucher : ''"
                  :showPage="false"
                ></preview-voucher>
                <!-- <machine-invoice
                  v-if="item.oriVoucher"
                  :showTitle="true"
                  :data="item.oriVoucher"
                  :list="item.oriVoucher ? item.oriVoucher.commodityList : []"
                ></machine-invoice> -->
              </div>
            </template>
          </div>
          <div>
            <p class="subtitle">二、机打发票</p>
            
            <template>
              <div v-for="(item, i) in serialsVouInvoice" :key="i">
                <preview-voucher :list="item.accVoucher ? item.accVoucher : ''" :showPage="false"></preview-voucher>
                <machine-invoice
                  :showTitle="true"
                  :data="item.oriVoucher"
                  :list="item.oriVoucher ? item.oriVoucher.commodityList : []"
                ></machine-invoice>
              </div>
            </template>
          </div>

          <div>
            <p class="subtitle">三、银行流水凭证</p>
            <template>
              <div v-for="(item, i) in serialsVouSerial" :key="i">
                <preview-voucher
                  :list="item.accVoucher ? item.accVoucher : ''"
                  :showPage="false"
                ></preview-voucher>
                <div style="background:#fff" v-for="(evt,index) in item.serialRowVOList" :key="index">
                  <div
                    style="padding:30px 0 30px 10px;font-weight: 700;"
                    class="table-title"
                  >{{ evt.name}}：{{ evt.bankNum }}</div>
                  <div>
                    <el-table
                      border
                      :span-method="arraySpanMethod"
                      :data="evt.bankSerialListList"
                      :header-cell-class-name="$setTableHeadRowClass"
                    >
                      <el-table-column label="交易日期" prop="tradingTime"></el-table-column>
                      <el-table-column label="摘要" prop="digest"></el-table-column>
                      <el-table-column label="对方户名" prop="oppAccountName">
                        <template slot-scope="scope">
                          <div
                            style="font-weight:bold"
                          >{{ scope.row.debitName }} {{ scope.row.oppAccountName }}</div>
                        </template>
                      </el-table-column>

                      <el-table-column label="借方发生额" prop="debitAmount">
                        <template slot-scope="scope">
                          <span>{{ $formatNumber(scope.row.debitAmount) }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column label="贷方发生额" prop="creditAmount">
                        <template slot-scope="scope">
                          <span>{{ $formatNumber(scope.row.creditAmount) }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column label="余额">
                        <template slot-scope="scope">
                          <span>{{ $formatNumber(scope.row.balance) }}</span>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </div>
              </div>

            </template>
          </div>
          <!-- 工资凭证 -->
          <div class="accountLookDetails-payroll" id="payroll" >
            <p class="subtitle">四、计提工资</p>
            <template>
              <div v-for="(item, i) in resObj.payrolls" :key="i">
                <preview-voucher
                  v-show="item.accVoucher"
                  ref="payroll"
                  :list="item.accVoucher ? item.accVoucher : ''"
                  :showPage="false"
                ></preview-voucher>
               
                <div class="accountLookDetails-table" v-show="item.oriVoucher.length>0">
                  <el-table
                    :data="item.oriVoucher ? item.oriVoucher : []"
                    :header-cell-class-name="$setTableHeadRowClassWhite" >
                    <el-table-column type="index" :index="$indexMethod" label="序号" width="50"></el-table-column>
                    <el-table-column label="部门" prop="dept"></el-table-column>
                    <el-table-column label="姓名" prop="name"></el-table-column>
                    <el-table-column label="基本工资" prop="basicsSalary">
                      <template slot-scope="scope">
                        <span>{{ $formatNumber(scope.row.basicsSalary) }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="岗位工资" prop="postSalary">
                      <template slot-scope="scope">
                        <span>{{ $formatNumber(scope.row.postSalary) }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="绩效工资" prop="meritSalary">
                      <template slot-scope="scope">
                        <span>{{ $formatNumber(scope.row.meritSalary) }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="年终奖" prop="yearEndBonus">
                      <template slot-scope="scope">
                        <span>{{ $formatNumber(scope.row.yearEndBonus) }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="扣款合计" prop="deduction">
                      <template slot-scope="scope">
                        <span>{{ $formatNumber(scope.row.deduction) }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column width="70" label="本月应发工资" prop="totalSalary">
                      <template slot-scope="scope">
                        <span>{{ $formatNumber(scope.row.totalSalary) }}</span>
                      </template>
                    </el-table-column>

                    <el-table-column label="个人负担部分" align="center">
                      <el-table-column width="70" label="大额医疗保险" prop="perBigMedical">
                        <template slot-scope="scope">
                          <span>{{ $formatNumber(scope.row.perBigMedical) }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column width="70" label="基本养老保险" prop="perAnnuity">
                        <template slot-scope="scope">
                          <span>{{ $formatNumber(scope.row.perAnnuity) }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column width="70" label="基本医疗保险" prop="perMedicare">
                        <template slot-scope="scope">
                          <span>{{ $formatNumber(scope.row.perMedicare) }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column width="80" label="失业保险" prop="perJobless">
                        <template slot-scope="scope">
                          <span>{{ $formatNumber(scope.row.perJobless) }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column width="70" label="住房公积金" prop="perHousingFund">
                        <template slot-scope="scope">
                          <span>{{ $formatNumber(scope.row.perHousingFund) }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column width="70" label="个人负担合计" prop="perBearTotal">
                        <template slot-scope="scope">
                          <span>{{ $formatNumber(scope.row.perBearTotal) }}</span>
                        </template>
                      </el-table-column>
                    </el-table-column>

                    <el-table-column label="单位负担部分" align="center">
                      <el-table-column width="70" label="社保" prop="firmSocialSecurity">
                        <template slot-scope="scope">
                          <span>{{ $formatNumber(scope.row.firmSocialSecurity) }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column width="70" label="公积金" prop="firmHousingFund">
                        <template slot-scope="scope">
                          <span>{{ $formatNumber(scope.row.firmHousingFund) }}</span>
                        </template>
                      </el-table-column>
                    </el-table-column>

                    <el-table-column width="95" label="个人所得税" prop="perTax">
                      <template slot-scope="scope">
                        <span>{{ $formatNumber(scope.row.perTax) }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column width="70" label="本月实发工资" prop="realIssueSalary">
                      <template slot-scope="scope">
                        <span>{{ $formatNumber(scope.row.realIssueSalary) }}</span>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </template>
          </div>
          

          <!-- 辅助核算凭证 -->
          <div class="distanceBotton" id="assistAccountings" >
            <p class="subtitle">五、辅助核算</p>
            <template>
              <div v-for="(item, i) in resObj.assistAccountings" :key="i">
                <preview-voucher :list="item ? item : ''" :showPage="false"></preview-voucher>
              </div>
            </template>
          </div>
          <!-- 流水凭证 -->
          <div class="accountLookDetails-bankStatement" id="bankStatement" >
            <p class="subtitle">六、银行流水汇总</p>
            <template>
              <div v-for="(val, i) in resObj.bankSerialList" :key="i" class="page-always">
                  <div style="background:#fff">
                    <div
                      style="padding:30px 0 30px 10px;font-weight: 700;"
                      class="table-title"
                    >{{ val.bankName }}：{{ val.bankNum }}</div>
                    <div>
                      <el-table
                        border
                        :span-method="arraySpanMethod"
                        :data="val.serialRows"
                        :header-cell-class-name="$setTableHeadRowClass"
                      >
                        <el-table-column label="交易日期" prop="tradingTime"></el-table-column>
                        <el-table-column label="摘要" prop="digest"></el-table-column>
                        <el-table-column label="对方户名" prop="oppAccountName">
                          <template slot-scope="scope">
                            <div
                              style="font-weight:bold"
                            >{{ scope.row.debitName }} {{ scope.row.oppAccountName }}</div>
                          </template>
                        </el-table-column>

                        <el-table-column label="借方发生额" prop="debitAmount">
                          <template slot-scope="scope">
                            <span>{{ $formatNumber(scope.row.debitAmount) }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column label="贷方发生额" prop="creditAmount">
                          <template slot-scope="scope">
                            <span>{{ $formatNumber(scope.row.creditAmount) }}</span>
                          </template>
                        </el-table-column>

                        <el-table-column label="备注">
                          <template slot-scope="scope">
                            <span>{{ scope.row.remark || "无" }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column label="余额">
                          <template slot-scope="scope">
                            <span>{{ $formatNumber(scope.row.balance) }}</span>
                          </template>
                        </el-table-column>
                      </el-table>
                    </div>
                  </div>
              </div>
            </template>
          </div>
          
            
        </div>
        
      </cc-bounced>
    
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import download from "_utils/download.js";
import machineHitInvoice from "./components/machineHitInvoice.vue";
import previewOfVoucher from "./components/previewOfVoucher.vue";
import axios from "axios";
export default {
  name: "accountLookDetails",
  props:{
    selectData:{
      type:Object
    },
    currentDate:{
      type:String
    }
  },
  data () {
    return {
      bouncedParam: {
        title: "",
        content: "",
        confirmBtn: "",
        layout:true,
        isCenter:false,
        visible: false,
        loading: false,
        canShowFooter:false
      },
      tableData: [],
      voucherType: "",
      payrollTable: [],
      bankStatementTable: [],
      serialsVouInvoice:[],
      serialsVouSerial:[],
      dataLoading:false,
      resObj: [],
      machineInvoiceCover: false,
      payrollCover: false,
      bankStatementCover: false,
      otherCover: false
    };
  },
  components: {
    "machine-invoice": machineHitInvoice,
    "preview-voucher": previewOfVoucher,
  },
  computed: {
    invokerObj () {
      return this.$store.state.ModulesUser;
    },
    ...mapGetters("ModulesUser", {
      currAccount: "GET_BOOKID"
    }),
  },
  created () {
    this.getData();
  },
  mounted () { },
  methods: {
    baseUrl (imgUrl) {
      function convertImgToBase64 (url, callback) {
        let canvas = document.createElement("canvas"),
          ctx = canvas.getContext("2d"),
          img = new Image();
        img.crossOrigin = "anonymous"; //解决Canvas.toDataURL 图片跨域问题
        img.onload = () => {
          canvas.height = img.height;
          canvas.width = img.width;
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
          let ext = img.src
            .substring(img.src.lastIndexOf(".") + 1)
            .toLowerCase(); // 获取到图片的格式
          let dataURL = canvas.toDataURL("image/" + ext); // 得到base64 编码的 dataURL
          callback && callback(dataURL);
          canvas = null;
        };
        img.src = url;
      }
      var baseUrl = "";
      convertImgToBase64(imgUrl, baseUrl => {
        baseUrl = baseUrl;
      });
    },
    getData () {
      let {$axios} = this;
      Object.assign(this.bouncedParam,{
        visible:true
      })
      this.dataLoading = true;
        $axios.https.post($axios.interfaceApi.detailSubjectVoucherInfo,{
          bookId:this.currAccount,
          date:this.currentDate,
          subjectCode:this.selectData.subjectCode
        })
        .then(res=>{
          this.dataLoading = false;
          let { serials,serialsTmp } = res;
          this.resObj = res;
          this.serialsVouInvoice = serials.vouInvoice;
          this.serialsVouSerial = serialsTmp.vouSerial;
       
        })
        .catch(req=>{
          this.dataLoading = false;
        })
    },
    arraySpanMethod ({ row, column, rowIndex, columnIndex }) {
      if (row.bankName && row.accountTemplateInfos) {
        if (columnIndex === 0) {
          return [1, 7];
        } else {
          return [0, 0];
        }
      }
    },
    //表格自定义合计
    getSummaries (param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (index <= 6) {
          sums[index] = "";
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = this.$formatNumber(sums[index]);
        } else {
          sums[index] = "--";
        }
      });
      return sums;
    },
    closeBounced(){
      this.$emit('closeHandle')
    }
  }
};
</script>

<style lang="scss" scoped>
.accountLookDetails {
  height: 65vh;
      width: 50vw;
  min-height: 500px;
  overflow-y: scroll;
  background: #fff;
  .subtitle {
    font-size: 18px;
    font-weight: 700;
    padding: 20px 10px;
    background: white;
  }
  .accountLookDetails-box {
    margin: 0 auto;
    //width: 1000px;
    width: 70%;
    min-width: 1328px;
    .accountLookDetails-title {
      text-align: right;
      padding: 15px;
      background: white;
    }
    .accountLookDetails-payroll,
    .accountLookDetails-bankStatement {
      background: white;
    }
    .accountLookDetails-middle,
    .accountLookDetails-payroll,
    .accountLookDetails-other {
      margin: 10px 0;
    }
    .accountLookDetails-bottom {
      .machineHitInvoice {
        padding: 20px;
      }
    }
    .accountLookDetails-middle,
    .accountLookDetails-table,
    .bankStatement-table {
      padding: 24px;
      background: white;
      .table-title {
        margin-bottom: 24px;
      }
    }
  }
}
</style>
